import React from 'react';

// Styles & Assets
import styles from './DialogAddZone.module.css';

// Services 
import { getEnvironmentApiUrl } from '../../../services/General';

// Hooks
import useInput from '../../../hooks/useInput';
import useHttp from '../../../hooks/useHttp';

// Components
import Input from '../../UI/Input/Input';
import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';

// Interfaces
import { Zone } from '../../../interfaces/Zone';

// Language
import { useTranslation } from 'react-i18next';

const DialogAddZoneBed: React.FC<{
    showModal: React.Dispatch<React.SetStateAction<boolean>>,
    callback: (zone: Zone) => void
}> = ({ showModal, callback }) => {

    const { t } = useTranslation();

    const { sendRequest: addZone } = useHttp<Zone>();

    const validateName = (name: string) => {
        if (name.trim() === '') return t('field_required');
        return true;
    };

    const { value, valueIsValid, hasError, errorMsg, valueChangeHandler, inputBlurHandler } = useInput(validateName);

    const handleConfirm = () => {
        inputBlurHandler();
        if (!valueIsValid) return;
        addZone({
            url: getEnvironmentApiUrl() + 'zone/', method: 'POST', body: { name: value }
        }, (zone) => callback(zone));
        showModal(false);
    };

    return (
        <div className={`dialog ${styles.dialog}`}>
            <h1 className={`dialogTitle ${styles.title}`}>{t('new_zone')}</h1>
            <Input
                label={t('zone_name')}
                defaultValue={value}
                error={hasError}
                errorMsg={errorMsg}
                onChange={valueChangeHandler}
                onBlur={inputBlurHandler}
            />
            <CancelConfirmButtons
                onCancel={() => showModal(false)}
                onConfirm={handleConfirm}
            />
        </div>
    );
};

export default DialogAddZoneBed;